import {Injectable} from '@angular/core';
import {HttpUtilsService} from '@core/services/http-utils.service';
import {map} from 'rxjs/operators';
import {moduleType} from '@shared/enums/module-type.enum';
import _ from 'lodash';
import {ILegendItem} from '@shared/interfaces/lineage';
import {ModuleUtilsService} from '@core/services/module-utils.service';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class E2EColumnDashboardService {
    legendTools = [];
    legendToolsUpdatedSubject = new Subject<void>();
    selectedLegendItems = {
        ETL: [],
        DB: [],
        REPORT: []
    };
    ETLToolsAndColors = {};
    DBToolsAndColors = {};
    REPORTToolsAndColors = {};
    ToolsAndColors = {};

    ETLColors = ['#00008B', '#0066b2', '#5072A7', '#007FFF', '#042b37', '#6CB4EE', '#89CFF0', '#00BFFF', '#6495ED', '#0039a6'];
    DBColors = ['#E01E5A', '#cd3161', '#b94569', '#a65870', '#b31848', '#861236', '#5a0c24'];
    REPORTColors = ['#2eb67d', '#3ca87b', '#499b79', '#578d76', '#648074', '#1c6d4b', '#124932'];

    constructor(
        private api: HttpUtilsService,
        private moduleUtilsService: ModuleUtilsService,
    ) {
    }

    getE2EData(payload: {
        connections: any[];
        type: string;
        mainSearch: string;
        innerSearch: string;
        from: number;
        filters: any;
        sort: string;
    }) {
        return this.api.post('lineage/E2EMainItems', payload)
            .pipe(
                map(response => {
                    switch (payload.type) {
                        case moduleType.ETL:
                            if (_.isEmpty(this.ETLToolsAndColors)) {
                                Object.keys(response.details).forEach((key, index) => {
                                    this.ETLToolsAndColors[key] = this.ETLColors[index];
                                });
                                this.ToolsAndColors[moduleType.ETL] = this.ETLToolsAndColors;
                            }
                            break;
                        case moduleType.DB:
                            if (_.isEmpty(this.DBToolsAndColors)) {
                                Object.keys(response.details).forEach((key, index) => {
                                    this.DBToolsAndColors[key] = this.DBColors[index];
                                });
                                this.ToolsAndColors[moduleType.DB] = this.DBToolsAndColors;
                            }
                            break;
                        case moduleType.REPORT:
                            if (_.isEmpty(this.REPORTToolsAndColors)) {
                                Object.keys(response.details).forEach((key, index) => {
                                    this.REPORTToolsAndColors[key] = this.REPORTColors[index];
                                });
                                this.ToolsAndColors[moduleType.REPORT] = this.REPORTToolsAndColors;
                            }
                            break;
                    }
                    return response;
                }),
            );
    }

    addLegendItem(index: number, key: string, text: string, type: any, strike: boolean) {
        this.legendTools.push({
            index,
            type,
            toolName: key,
            text,
            strike,
        });
    }

    getLegendItem(type: string, key: string) {
        return this.legendTools.find((item: ILegendItem) => item.type === type && item.toolName.toUpperCase() === key.toUpperCase());
    }

    getLegendItems(type) {
        return this.legendTools.filter((item: ILegendItem) => item.type === type);
    }
}
